// extracted by mini-css-extract-plugin
export default {"body":"style_body__NfiA0","container":"style_container__t9yy0"};